import signedFetch from '../util/signedFetch.js';

const generateUsernameUrl = orgId => `${__API_BASE__}/org/${encodeURIComponent(orgId.trim())}/generate-username`;

export default (orgId, firstName, lastName) =>
  signedFetch('generateUsername', generateUsernameUrl(orgId), 'POST', { orgId, firstName, lastName });
